import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'

import { Formik, Field } from 'formik'

import { useUser } from 'contexts/user.context'

import DeleteAccountModal from 'components/deleteAccountModal'

import { TRAVEL_INTERESTS } from 'travelInterests'

import {
  Container,
  Description,
  Title,
  TitleContainer,
  Divider,
  AccordionButton,
  AccordionPanel,
  DangerButton,
  SaveButton,
  Label,
  Input,
  EditForm,
  TextArea,
  CheckboxWrapper,
  CheckboxContainer,
  Form,
  BackButton,
  ButtonFooter,
  FileInput,
  Select,
  CoverImage,
  ProfileImage
} from './style'

const Update = () => {
  const { updateUser, user, uploadFile, getUserData } = useUser()

  const interests = Array.isArray(user?.interests)
    ? user.interests
        .map((item: any) => {
          if (typeof item === 'string') return item
          if (typeof item?.interest === 'string') return item.interest
          return item?.interest?.name || item?.name || null
        })
        .filter(Boolean)
    : []

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [pendingProfilePicture, setPendingProfilePicture] = useState<
    string | undefined
  >(undefined)
  const [pendingCoverPicture, setPendingCoverPicture] = useState<
    string | undefined
  >(undefined)

  const uploadFileCallback = async (file?: File, purpose?: string) => {
    if (!file) return null

    try {
      return await uploadFile(file, purpose)
    } catch (error: any) {
      toast.error(error?.message || 'Não foi possível enviar a imagem.', {
        position: 'top-right',
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        theme: 'dark'
      })
      return null
    }
  }

  const Collapse = (props: any) => {
    const [visible, setVisible] = useState(false)

    function isOpen() {
      setVisible(!visible)
    }

    return (
      <>
        <AccordionButton
          type="button"
          onClick={isOpen}
          aria-expanded={visible}
          $open={visible}
        >
          <span>{props.title}</span>
          <strong>{visible ? '−' : '›'}</strong>
        </AccordionButton>
        {visible && <AccordionPanel>{props.hiddenContent}</AccordionPanel>}
      </>
    )
  }

  const validate = (values: any) => {
    const errors: any = {}

    if (!values.email) {
      errors.email = 'Campo obrigatório'
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = 'E-mail inválido'
    }
    if (!values.password) {
      errors.password = 'Insira sua senha'
    }
    if (!values.firstname) {
      errors.firstname = 'Este campo é obrigatório'
    }
    if (!values.lastname) {
      errors.lastname = 'Este campo é obrigatório'
    }
    if (!values.birthdate) {
      errors.birthdate = 'Este campo é obrigatório'
    }
    if (values.password && values.password.length < 6) {
      errors.password = 'Insira no mínimo 6 caracteres'
    }
    if (values.password !== values.confirmPassword) {
      errors.confirmPassword = 'Senhas não conferem'
    }
    if (!values.confirmPolicy) {
      errors.confirmPolicy = 'Campo obrigatório'
    }
    return errors
  }

  const history = useHistory()

  if (!user) {
    return (
      <Container>
        <TitleContainer>
          <Title>Editar perfil</Title>
          <Description>Carregando seus dados...</Description>
        </TitleContainer>
      </Container>
    )
  }

  return (
    <Container>
      {isModalVisible && (
        <DeleteAccountModal
          isOpen
          closeModal={() => setIsModalVisible(false)}
        />
      )}
      <TitleContainer>
        <Title>Editar perfil</Title>
        <Description>Atualize seus dados e preferências.</Description>
      </TitleContainer>
      <Divider />
      {user && (
        <Formik
          initialValues={{
            firstname: user.firstname,
            lastname: user.lastname,
            email: user.email,
            facebook: user?.facebook ?? '',
            instagram: user?.instagram ?? '',
            birthdate: user.birthdate
              ? String(user.birthdate).slice(0, 10)
              : '',
            about: user.about ?? '',
            interests: interests,
            gender: user.gender ?? '',
            coverPicture: user.coverPicture ?? '',
            profilePicture: user.profilePicture ?? ''
          }}
          // validate={validate}
          onSubmit={async (values, { setSubmitting }) => {
            try {
              await updateUser({
                ...values,
                profilePicture:
                  pendingProfilePicture !== undefined
                    ? pendingProfilePicture
                    : values.profilePicture,
                coverPicture:
                  pendingCoverPicture !== undefined
                    ? pendingCoverPicture
                    : values.coverPicture
              })

              // Confirm the server-persisted profile before leaving the editor.
              await getUserData()
              setPendingProfilePicture(undefined)
              setPendingCoverPicture(undefined)
              history.push('/minha-conta')
            } catch {
              toast.error('Não foi possível salvar os dados', {
                position: 'top-right',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: 'dark'
              })
            }
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue
          }) => (
            <Form onSubmit={handleSubmit}>
              <Collapse
                title="Dados Pessoais"
                hiddenContent={
                  <EditForm>
                    <label>Nome</label>
                    <Field
                      as={Input}
                      name="firstname"
                      type="text"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.firstname}
                    />
                    {errors.firstname && <span>{errors.firstname}</span>}

                    <Label>Sobrenome</Label>
                    <Field
                      as={Input}
                      name="lastname"
                      type="text"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.lastname}
                    />
                    {errors.lastname && <span>{errors.lastname}</span>}

                    <Label>Data de Nascimento</Label>
                    <Field
                      as={Input}
                      name="birthdate"
                      type="date"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.birthdate}
                    />
                    {errors.birthdate && <span>{errors.birthdate}</span>}

                    <Label>Gênero</Label>
                    <Field
                      name="gender"
                      as={Select}
                      placeholder="Selecione uma opção"
                    >
                      <option value="M">Masculino</option>
                      <option value="F">Feminino</option>
                      <option value="NB">Não binário</option>
                      <option value="AN">Outro</option>
                    </Field>
                    {errors.gender && <span>{errors.gender}</span>}
                  </EditForm>
                }
              />

              <Collapse
                title="Informações sobre o usuário"
                hiddenContent={
                  <EditForm>
                    <Label>Sobre você</Label>
                    <Field
                      name="about"
                      as={TextArea}
                      onBlur={handleBlur}
                      value={values.about}
                      onChange={handleChange}
                      placeholder="Queremos saber mais! Qual seu perfil de viajante? Qual foi sua melhor viagem? Do que você mais gosta?"
                    />
                    <CheckboxWrapper>
                      {TRAVEL_INTERESTS.map((interest) => (
                        <CheckboxContainer key={interest.value}>
                          <Field
                            id={`profile-interest-${interest.value}`}
                            name="interests"
                            value={interest.value}
                            type="checkbox"
                          />
                          <Label htmlFor={`profile-interest-${interest.value}`}>
                            {interest.label}
                          </Label>
                        </CheckboxContainer>
                      ))}
                    </CheckboxWrapper>
                  </EditForm>
                }
              />

              <Collapse
                title="Dados de Acesso"
                hiddenContent={
                  <EditForm>
                    <Label>E-mail</Label>
                    <Field
                      as={Input}
                      name="email"
                      type="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                    />
                    {errors.email && <span>{errors.email}</span>}
                  </EditForm>
                }
              />

              <Collapse
                title="Redes sociais"
                hiddenContent={
                  <EditForm>
                    <Label>Instagram</Label>
                    <Field
                      as={Input}
                      type="text"
                      name="instagram"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.instagram}
                      placeholder="redsterna_ig"
                    />
                    <Description>
                      Complete somente com seu nome de usuário (sem @)
                    </Description>
                    <Label>Facebook</Label>
                    <Description>
                      Complete somente com seu nome de usuário
                      (https://www.facebook.com/o nome que aparece aqui)
                    </Description>
                    <Field
                      as={Input}
                      type="text"
                      name="facebook"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.facebook}
                      placeholder="redsterna_fb"
                    />
                  </EditForm>
                }
              />

              <Collapse
                title="Fotos"
                hiddenContent={
                  <EditForm>
                    <Label>Foto de Perfil</Label>
                    <FileInput
                      type="file"
                      data-label="Escolha a foto de perfil"
                      accept=".jpg,.jpeg,.png,.webp,.avif,.heic,.heif,image/jpeg,image/png,image/webp,image/avif,image/heic,image/heif"
                      onChange={async (e: any) => {
                        const response = await uploadFileCallback(
                          e.target.files?.[0],
                          'profile_picture'
                        )
                        e.target.value = ''

                        if (!response) return

                        setPendingProfilePicture(response)
                        setFieldValue('profilePicture', response)
                      }}
                    />
                    {values.profilePicture && values.profilePicture !== '' && (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start'
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-end',
                            marginTop: 10
                          }}
                        >
                          <button
                            type="button"
                            onClick={() => {
                              setPendingProfilePicture('')
                              setFieldValue('profilePicture', '')
                            }}
                          >
                            X
                          </button>
                          <ProfileImage
                            src={values.profilePicture}
                            alt="cover"
                          />
                        </div>
                      </div>
                    )}
                    <Label>Foto de Capa</Label>
                    <FileInput
                      type="file"
                      data-label="Escolha sua foto de capa"
                      accept=".jpg,.jpeg,.png,.webp,.avif,.heic,.heif,image/jpeg,image/png,image/webp,image/avif,image/heic,image/heif"
                      onChange={async (e: any) => {
                        const response = await uploadFileCallback(
                          e.target.files?.[0],
                          'profile_cover'
                        )
                        e.target.value = ''

                        if (!response) return

                        setPendingCoverPicture(response)
                        setFieldValue('coverPicture', response)
                      }}
                    />
                    {values.coverPicture && values.coverPicture !== '' && (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start'
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-end',
                            marginTop: 10
                          }}
                        >
                          <button
                            type="button"
                            onClick={() => {
                              setPendingCoverPicture('')
                              setFieldValue('coverPicture', '')
                            }}
                          >
                            X
                          </button>
                          <CoverImage src={values.coverPicture} alt="cover" />
                        </div>
                      </div>
                    )}
                  </EditForm>
                }
              />

              <ButtonFooter>
                <BackButton to="/minha-conta">Voltar</BackButton>
                <SaveButton type="submit" disabled={isSubmitting}>
                  {isSubmitting ? 'Salvando...' : 'Salvar alterações'}
                </SaveButton>
              </ButtonFooter>
              <DangerButton
                onClick={() => setIsModalVisible(true)}
                type="button"
              >
                Excluir conta
              </DangerButton>
            </Form>
          )}
        </Formik>
      )}
    </Container>
  )
}

export default Update
